import {BaseMachineType} from './base-machine-type';
import {EquipmentManufacturer} from './equipment-manufacturer';
import {MachineType} from './machine-type.enum';

export class OverviewListMachineType extends BaseMachineType {
  private _machineType: MachineType;

  public constructor(id: number, name: string, machineType: MachineType, manufacturer?: EquipmentManufacturer, model?: string) {
    super(id, name, manufacturer, model);
    this._machineType = machineType;
  }

  public static fromJSON(machineTypeJSON: any): OverviewListMachineType {
    return new OverviewListMachineType(
      machineTypeJSON.id,
      machineTypeJSON.name,
      machineTypeJSON.machineType,
      new EquipmentManufacturer(machineTypeJSON.manufacturerId, machineTypeJSON.manufacturerName),
      machineTypeJSON.model
    );
  }

  public get machineType(): MachineType {
    return this._machineType;
  }

  public set machineType(machineType: MachineType) {
    this._machineType = machineType;
  }
}
